export const OfficeFluidContainerPackageName = '@ms/office-fluid-container';
export const OneNoteMeetingPackageName = '@ms/onenote-meetings';
